import React from 'react';
import { Search, ExternalLink } from 'lucide-react';

const topQueries = [
  { id: 'q-001', query: 'acme', impressions: 9840, clicks: 3120, ctr: 31.7, position: 1.1 },
  { id: 'q-002', query: 'acme.io', impressions: 5430, clicks: 1980, ctr: 36.5, position: 1.0 },
  { id: 'q-003', query: 'acme dashboard', impressions: 2870, clicks: 820, ctr: 28.6, position: 1.3 },
  { id: 'q-004', query: 'acme login', impressions: 2240, clicks: 710, ctr: 31.7, position: 1.2 },
  { id: 'q-005', query: 'acme pricing', impressions: 1680, clicks: 490, ctr: 29.2, position: 1.5 },
];

export default function TopQueryCard() {
  return (
    <div className="bg-white border border-[#e7e7e7] rounded-[5px] p-5 hover:shadow-[rgba(150,25,50,0.08)_0px_8px_24px] transition-all duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {/* Smarty-style icon wrapper: blue bg */}
          <div
            className="w-[42px] h-[42px] rounded-[5px] flex items-center justify-center"
            style={{ backgroundColor: 'rgb(224, 240, 253)' }}
          >
            <Search size={18} className="text-[#39364E]" />
          </div>
          <div>
            <p className="text-xs font-500 uppercase tracking-wide text-[#696969]">Top Branded Queries</p>
            <p className="text-[11px] text-[#696969]">Last 7 days · acme.io</p>
          </div>
        </div>
        <button className="flex items-center gap-1 text-[11px] text-[#961932] font-500 hover:underline">
          View all <ExternalLink size={11} />
        </button>
      </div>
      <div className="overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#e7e7e7]">
              <th className="text-left pb-2 text-[11px] font-500 uppercase tracking-wide text-[#696969] pr-4">Query</th>
              <th className="text-right pb-2 text-[11px] font-500 uppercase tracking-wide text-[#696969] px-3">Impressions</th>
              <th className="text-right pb-2 text-[11px] font-500 uppercase tracking-wide text-[#696969] px-3">Clicks</th>
              <th className="text-right pb-2 text-[11px] font-500 uppercase tracking-wide text-[#696969] px-3">CTR</th>
              <th className="text-right pb-2 text-[11px] font-500 uppercase tracking-wide text-[#696969] pl-3">Avg Pos.</th>
            </tr>
          </thead>
          <tbody>
            {topQueries?.map((q, i) => (
              <tr
                key={q?.id}
                className={`group hover:bg-[rgba(150,25,50,0.04)] transition-colors duration-100 ${
                  i < topQueries?.length - 1 ? 'border-b border-[rgba(231,231,231,0.7)]' : ''
                }`}
              >
                <td className="py-2.5 pr-4">
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-500 tabular-nums text-[#696969] w-4">{i + 1}</span>
                    <span className="font-mono text-[13px] font-500 text-[#39364E]">{q?.query}</span>
                    {i === 0 && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-600 bg-[rgba(150,25,50,0.08)] text-[#961932]">
                        Top
                      </span>
                    )}
                  </div>
                </td>
                <td className="py-2.5 px-3 text-right text-[13px] tabular-nums text-[#39364E] font-500">
                  {q?.impressions?.toLocaleString()}
                </td>
                <td className="py-2.5 px-3 text-right text-[13px] tabular-nums text-[#39364E]">
                  {q?.clicks?.toLocaleString()}
                </td>
                <td className="py-2.5 px-3 text-right text-[13px] tabular-nums">
                  <span className="text-emerald-600 font-500">{q?.ctr}%</span>
                </td>
                <td className="py-2.5 pl-3 text-right text-[13px] tabular-nums text-[#39364E]">
                  {q?.position}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}